// @flow

// Modules
import WsPush from '@winamax/wspush-client';

// Methods
import Token from './token';

/**
 * Constants / Variables
 */

const METHODS = {
  CONFIGURATION: 'GetChallengePublicConfiguration',
  CHALLENGE_RANKING: 'GetChallengePublicRanking',
  CHALLENGE_USER_RANKING: 'GetChallengePublicUserRanking',
  URL_LIMIT_TRANSLATION: 'GetChallengePublicInfo'
};

// Ids of specific messages
let ids = {
  configuration: null,
  challenge: null,
  limitTranslation: null
};

// Is socket connected ?
let connected = false;

// Is socket authenticated ?
let authenticated = false;

// Last token sended
let lastJwtToken = null;

/**
 * Methods
 */

const getLanguageShort = function (language: string): string {
  if (language === 'fr_FR') {
    return 'fr';
  } else if (language === 'es_ES') {
    return 'es';
  } else if (language === 'de_DE') {
    return 'de';
  } else {
    return 'en';
  }
};

/**
 * Component
 */
let WsPushClient: Object = {};

WsPushClient.socketConnection = function (env, operator, callback) {
  WsPush.initialize(env, operator, callback);
  WsPush.connect();
};

WsPushClient.getInfos = function () {
  return {
    ids,
    connected,
    authenticated
  };
};

WsPushClient.setConnected = function (value: boolean) {
  connected = value;
};

WsPushClient.setAuthenticated = function (value: boolean) {
  authenticated = value;
};

WsPushClient.getConfiguration = function (language: string, operator: string) {
  ids.configuration = WsPush.call(
    METHODS.CONFIGURATION,
    {
      operator_name: operator || 'wam',
      lang: getLanguageShort(language) || 'en'
    },
    'poker/challenge'
  );
};

WsPushClient.getSpecificChallenge = (operation_name: string, type: string, date: number) => {
  ids.challenge = WsPush.call(
    authenticated ? METHODS.CHALLENGE_USER_RANKING : METHODS.CHALLENGE_RANKING,
    {
      operation_name,
      accumulator_name: type,
      date
    },
    'poker/challenge'
  );
};

WsPushClient.getUrlLimitTranslation = (challenge_type: string, limit: string) => {
  ids.limitTranslation = WsPush.call(
    METHODS.URL_LIMIT_TRANSLATION,
    {
      challenge_type,
      limit
    },
    'poker/challenge'
  );
};

WsPushClient.generateToken = function (getToken?: any, webEndpoint?: any) {
  if (getToken) {
    getToken().then((data) => {
      WsPushClient.setAuthenticate(data.token);
    });
  } else if (__BUILD_TARGET__ === 'web') {
    Token.getWebToken((webToken) => WsPushClient.setAuthenticate(webToken), webEndpoint);
  }
};

WsPushClient.setAuthenticate = function (jwtToken) {
  if (jwtToken && jwtToken !== lastJwtToken) {
    lastJwtToken = jwtToken;

    WsPush.authenticate(jwtToken);
  }
};

WsPushClient.disconnect = function () {
  WsPush.disconnect();

  // Reset connection infos
  connected = false;
  authenticated = false;
  lastJwtToken = null;
};

export default WsPushClient;
